import { useState, type CSSProperties } from 'react';
import type { Customer } from '@setapart/shared';
import { FONTS, COLORS } from '@setapart/shared';
import { connectShopifyUrl } from '../lib/api';

interface Props {
  customer: Customer;
  onDone: () => void;
}

export function Connect({ customer: _customer, onDone }: Props) {
  const [brandId, setBrandId] = useState('');
  const [shop, setShop] = useState('');

  function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!brandId || !shop) return;
    const normShop = shop.trim().toLowerCase().replace(/^https?:\/\//, '').replace(/\/.*$/, '');
    const finalShop = normShop.endsWith('.myshopify.com') ? normShop : `${normShop}.myshopify.com`;
    window.location.href = connectShopifyUrl(brandId, finalShop);
  }

  return (
    <div>
      <div style={{ fontSize: 10, letterSpacing: '0.4em', textTransform: 'uppercase', fontWeight: 700, color: COLORS.accent, marginBottom: 8 }}>
        CONNECT SHOPIFY
      </div>
      <h1 style={{ fontFamily: FONTS.display, fontSize: 28, color: COLORS.ink, fontStyle: 'italic', fontWeight: 500, margin: 0 }}>
        Install the Set Apart app
      </h1>
      <p style={{ fontSize: 14, color: COLORS.muted, marginTop: 8, maxWidth: 520, lineHeight: 1.5 }}>
        Enter your brand id (from onboarding) and Shopify store domain. You'll be bounced
        to Shopify to approve the install, then back here.
      </p>

      <form onSubmit={onSubmit} style={{ marginTop: 20, maxWidth: 420 }}>
        <label style={labelStyle}>Brand ID</label>
        <input value={brandId} onChange={(e) => setBrandId(e.target.value)} placeholder="uuid from onboarding" style={inputStyle} />

        <label style={{ ...labelStyle, marginTop: 16 }}>Shopify store</label>
        <input
          value={shop}
          onChange={(e) => setShop(e.target.value)}
          placeholder="your-store.myshopify.com"
          style={inputStyle}
        />

        <button type="submit" style={primaryBtn}>Continue to Shopify →</button>
      </form>

      <button onClick={onDone} style={secondaryBtn}>← Back to dashboard</button>
    </div>
  );
}

const labelStyle: CSSProperties = {
  display: 'block',
  fontSize: 10,
  letterSpacing: '0.3em',
  textTransform: 'uppercase',
  fontWeight: 700,
  color: COLORS.muted,
  marginBottom: 6,
};
const inputStyle: CSSProperties = {
  width: '100%',
  padding: '12px 14px',
  borderRadius: 12,
  border: `1px solid ${COLORS.sand}`,
  background: '#fff',
  fontFamily: FONTS.body,
  fontSize: 14,
  color: COLORS.ink,
};
const primaryBtn: CSSProperties = {
  marginTop: 18,
  padding: '12px 20px',
  borderRadius: 999,
  background: COLORS.ink,
  color: COLORS.cream,
  border: 'none',
  cursor: 'pointer',
  fontSize: 11,
  letterSpacing: '0.3em',
  textTransform: 'uppercase',
  fontWeight: 700,
};
const secondaryBtn: CSSProperties = {
  marginTop: 16,
  padding: '8px 0',
  background: 'transparent',
  border: 'none',
  cursor: 'pointer',
  fontSize: 11,
  letterSpacing: '0.3em',
  textTransform: 'uppercase',
  fontWeight: 700,
  color: COLORS.muted,
};
